import { css } from 'styled-components';
import * as colors from '../colors';

export const whiteTooltipStyles = css`
  .tooltip-white {
    opacity: 1 !important;

    .tooltip-inner {
      max-width: 270px;
      background-color: transparent;
      color: ${colors.darkBlue} !important;
      text-align: left;
      padding: 0;
      box-shadow: 1px 2px 5px rgba(10, 20, 100, 0.2);
      line-height: 16.8px;

      & > * {
        border-radius: 4px;
      }
    }
  }

  .tooltip-narrow {
    max-width: 190px !important;
  }

  .tooltip-white.bs-tooltip-top .arrow:before {
    border-top-color: ${colors.white};
  }

  .tooltip-white.bs-tooltip-bottom .arrow:before {
    border-bottom-color: ${colors.white};
  }

  .tooltip-white.bs-tooltip-right .arrow:before {
    border-right-color: ${colors.white};
  }

  .tooltip-white.bs-tooltip-left .arrow:before {
    border-left-color: ${colors.white};
  }
`;

export const blackTooltipStyles = css`
  .tooltip-black.tooltip {
    .tooltip-inner {
      padding: 10px 30px;
      border-radius: 8px;
      background-color: ${colors.darkBlue};
    }
  }

  .tooltip-black.tooltip.show {
    opacity: 1;
  }

  .tooltip-black.bs-tooltip-top .arrow:before {
    border-top-color: ${colors.darkBlue};
  }

  .tooltip-black.bs-tooltip-bottom .arrow:before {
    border-bottom-color: ${colors.darkBlue};
  }

  .tooltip-black.bs-tooltip-right .arrow:before {
    border-right-color: ${colors.darkBlue};
  }

  .tooltip-black.bs-tooltip-left .arrow:before {
    border-left-color: ${colors.darkBlue};
  }
`;

export const draxTooltipStyles = css`
  .tooltip-drax.tooltip {
    .tooltip-inner {
      padding: 10px 30px;
      background-color: ${colors.draxElectricTurquoise};
      color: ${colors.draxDarkBlue};
      font-weight: 400;
    }
  }

  .tooltip-drax.tooltip.show {
    opacity: 1;
  }

  .tooltip-drax.bs-tooltip-top .arrow:before {
    border-top-color: ${colors.draxElectricTurquoise};
  }

  .tooltip-drax.bs-tooltip-bottom .arrow:before {
    border-bottom-color: ${colors.draxElectricTurquoise};
  }

  .tooltip-drax.bs-tooltip-right .arrow:before {
    border-right-color: ${colors.draxElectricTurquoise};
  }

  .tooltip-drax.bs-tooltip-left .arrow:before {
    border-left-color: ${colors.draxElectricTurquoise};
  }
`;
